// src/app/pages/orders/CreateOrderModal.js

import React, { useEffect, useState } from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions, Select, MenuItem, InputLabel, FormControl,
  Grid, Button, TextField, Typography, Stack, Box
} from '@mui/material';
import customerServices from 'app/services/customer-services';
import centreServices from 'app/services/centre-services';

const CreateOrderModal = ({
  open,
  onClose,
  onSubmit,
  newOrder,
  setNewOrder,
  newProduct,
  setNewProduct
}) => {
  const [customers, setCustomers] = useState([]);
  const [centres, setCentres] = useState([]);

  const handleAddProduct = () => {
    if (newProduct.name && newProduct.quantity) {
      setNewOrder({
        ...newOrder,
        products: [...newOrder.products, newProduct]
      });
      setNewProduct({ name: '', quantity: '' });
    }
  };

  const handleRemoveProduct = (index) => {
    const updated = newOrder.products.filter((_, i) => i !== index);
    setNewOrder({ ...newOrder, products: updated });
  };

  useEffect(() => {
    customerServices.searchByCompany().then(setCustomers);
    centreServices.searchByCompany().then(setCentres);
  }, []);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{ sx: { width: '800px', maxWidth: '90%' } }}
    >
      <DialogTitle>
        <Typography variant="h2" color="primary">Crear nuevo pedido</Typography>
      </DialogTitle>

      <DialogContent dividers>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="customer-label">Cliente</InputLabel>
              <Select
                labelId="customer-label"
                value={newOrder.customerId || ''}
                onChange={(e) => setNewOrder({ ...newOrder, customerId: e.target.value })}
                label="Cliente"
              >
                {customers.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <FormControl fullWidth>
              <InputLabel id="centre-label">Centro</InputLabel>
              <Select
                labelId="centre-label"
                value={newOrder.centreId || ''}
                onChange={(e) => setNewOrder({ ...newOrder, centreId: e.target.value })}
                label="Centro"
              >
                {centres.map((c) => (
                  <MenuItem key={c.id} value={c.id}>
                    {c.name}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Grid>

          <Grid item xs={12}>
            <TextField
              label="Fecha de creación"
              type="date"
              fullWidth
              InputLabelProps={{ shrink: true }}
              value={newOrder.creationDate}
              onChange={(e) => setNewOrder({ ...newOrder, creationDate: e.target.value })}
            />
          </Grid>

          <Grid item xs={7}>
            <TextField
              label="Producto"
              fullWidth
              value={newProduct.name}
              onChange={(e) => setNewProduct({ ...newProduct, name: e.target.value })}
            />
          </Grid>

          <Grid item xs={3}>
            <TextField
              label="Cantidad"
              type="number"
              fullWidth
              value={newProduct.quantity}
              onChange={(e) => setNewProduct({ ...newProduct, quantity: e.target.value })}
            />
          </Grid>

          <Grid item xs={2}>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleAddProduct}
            >
              Agregar
            </Button>
          </Grid>

          <Grid item xs={12}>
            <Stack direction="column" spacing={1}>
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  borderBottom: '1px solid #000',
                  py: 1,
                  fontWeight: 'bold',
                  px: 1
                }}
              >
                <Box sx={{ flex: 2 }}>
                  <Typography variant="body2">Producto</Typography>
                </Box>
                <Box sx={{ flex: 1 }}>
                  <Typography variant="body2">Cantidad</Typography>
                </Box>
                <Box sx={{ width: 80 }} />
                <Box sx={{ width: 80 }} />
              </Box>

              {newOrder.products.map((p, index) => (
                <Box
                  key={index}
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between',
                    borderBottom: '1px solid #ddd',
                    py: 1,
                    px: 1
                  }}
                >
                  <Box sx={{ flex: 2 }}>
                    <Typography variant="body2" noWrap>{p.name}</Typography>
                  </Box>

                  <Box sx={{ flex: 1 }}>
                    <Typography variant="body2">{p.quantity}</Typography>
                  </Box>

                  <Box sx={{ width: 80 }}>
                    <Button
                      size="small"
                      color="primary"
                      variant="outlined"
                      fullWidth
                      onClick={() => {
                        setNewProduct({ name: p.name, quantity: p.quantity });
                        handleRemoveProduct(index);
                      }}
                    >
                      Editar
                    </Button>
                  </Box>

                  <Box sx={{ width: 80 }}>
                    <Button
                      size="small"
                      color="error"
                      fullWidth
                      onClick={() => handleRemoveProduct(index)}
                    >
                      Eliminar
                    </Button>
                  </Box>
                </Box>
              ))}
            </Stack>
          </Grid>
        </Grid>
      </DialogContent>

      <DialogActions>
        <Button onClick={onClose}>Cancelar</Button>
        <Button variant="contained" color="success" onClick={onSubmit}>
          Crear pedido
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default CreateOrderModal;
